import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { CartButtonComponent } from '../cart-button/cart-button.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { MenuModule } from 'primeng/menu';
import { FormsModule } from '@angular/forms';
import { ShippingSelectorComponent } from '../shipping-selector/shipping-selector.component';
import { QuantitySelectorComponent } from '../quantity-selector/quantity-selector.component';
import { AdjustItemQuantityMutation, AdjustItemQuantityMutationVariables, Order, OrderLine, Product, RemoveItemFromCartMutation, RemoveItemFromCartMutationVariables, SearchResult } from '../../../../graphql/generated/generated-types';
import { FormatSearchResultPriceTemplatePipe } from './../../../../shared/pipes/format-search-result-price-template.pipe'
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Observable, Subject, take, takeUntil } from 'rxjs';
import { Platform } from '@angular/cdk/platform';
import { ActiveService } from '../../../../core/providers/active/active.service';
import { NotAvailableOverlayComponent } from '../../not-available-overlay/not-available-overlay.component';
import { environment } from '../../../../../environments/environment';
import { SavedItemsService } from '../../../services/saved-items.service';
import { FormatPricePipe } from '../../../pipes/format-price.pipe';
import { IBenefits, ItemBenefitsComponent } from '../item-benefits/item-benefits.component';
import { ADJUST_ITEM_QUANTITY, REMOVE_ITEM_FROM_CART } from '../price-and-actions-block/product-cart.graphql';
import { ToastSeverity } from '../../../notification/notification.component';
import { DataService } from '../../../../core/providers/data/data.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-product-cto-block',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    FormsModule,
    MenuModule,
    CartButtonComponent,
    ShippingSelectorComponent,
    QuantitySelectorComponent,
    FormatPricePipe,
    FormatSearchResultPriceTemplatePipe,
    ProgressSpinnerModule,
    NotAvailableOverlayComponent,
    ItemBenefitsComponent
  ],
  templateUrl: './product-cto-block.component.html',
  styleUrl: './product-cto-block.component.scss'
})
export class ProductCtoBlockComponent implements OnInit, OnDestroy {
  public activeOrder$: Observable<Order>;
  public qtyInCart: { [id: string]: number } = {};
  public orderLineInCart: { [id: string]: OrderLine } = {};

  @Input() product!: Product;
  @Input() searchResult!: SearchResult;

  @Input() showSaveAction!: boolean;
  @Input() shippingMethods: SearchResult[] = [];
  @Input() quantity: number | undefined = 1;
  @Input() quantityEnabled: boolean = true;
  @Input() shippingEnabled: boolean = true;


  @Input() shopCtoBlockStyles: boolean = false;

  private unsubscribe$ = new Subject<void>();


  public enableSavedItems: boolean = environment.websiteSettings.enableSavedItems;
  public productInSaved?: boolean = false;

  public itemBenefits: IBenefits = {
    shippingWeeksMin: 2,
    shippingWeeksMax: 4
  }

  public stockLevel!: number;

  constructor(private platform: Platform, private activeService: ActiveService,
    private savedItemsService: SavedItemsService
  ) {

  }
  ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.subscribeToActiveOrder();
      this.productInSaved = this.savedItemsService.productInSaved(this.product ? this.product?.id : this.searchResult.productId);
    }

    if (this.product) {
      this.stockLevel = this.convertStringToNumber(this.product.variants[0].stockLevel || '0');
    }

    if(this.searchResult){
      this.stockLevel = this.convertStringToNumber(this.searchResult.customAttributes?.stockLevel || '0');
    }


  }

  public convertStringToNumber(value: string): number{
    
    return parseFloat(value);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  
  public addItemToSaved(productId: any){
    this.savedItemsService.addProductToSavedItems(productId);
    this.productInSaved = this.savedItemsService.productInSaved(productId);
  }


  public subscribeToActiveOrder() {
    this.unsubscribe$.next();
    this.activeService.activeOrder$.pipe(takeUntil(this.unsubscribe$)).subscribe(order => {

      this.qtyInCart = {};
      this.orderLineInCart = {};
      for (const line of order?.lines ?? []) {
        this.qtyInCart[line.productVariant.id] = line.quantity;
        this.orderLineInCart[line.productVariant.id] = line;
      }
    })
  }


}
